import React from "react";
import { useTranslation } from 'react-i18next';
import "./VisionSection.css";

// Import images
import vision1 from "../../assets/images/الدقة في التنفيذ.png";
import vision2 from "../../assets/images/الريادة في السوق.png";
import vision3 from "../../assets/images/استثمار في الكفاءات.png";
import vision4 from "../../assets/images/التوسع الإستراتيجي.png";
import vision5 from "../../assets/images/مساهمة وطنية.png";

const VisionSection = () => {
  const { t } = useTranslation();
  const isRTL = t('dir') === 'rtl';

  const cards = t('vision.cards', { returnObjects: true });

  // Replace icon field with imported images
  const cardImages = [vision1, vision2, vision3, vision4, vision5];

  return (
    <section className="vision-section" dir={t('dir')}>
      <div className="section-container">
        <div className="vision-header">
          <h2 className="vision-title">{t('vision.title')}</h2>
          <div className="vision-divider">
            <span className="divider-line"></span>
            <span className="divider-diamond">◆</span>
            <span className="divider-line"></span>
          </div>
          <p className="vision-subtitle">
            {t('vision.subtitle')}
          </p>
        </div>
      </div>

      <div className="section-container">
        <div className="vision-grid">
          {cards.map((card, index) => (
            <div className="vision-card section-container" key={index}>
              <div className="card-icon-wrapper">
                <img src={cardImages[index]} alt={card.title} className="card-icon" />
                <div className="icon-backdrop"></div>
              </div>
              <h3 className="vision-card-title">{card.title}</h3>
              <p className="card-description">{card.description}</p>
              <div className="card-border"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
